(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationCruiseComponentDetails',
	};

	var $form;

	var _formatCityName,
	    _getCruiseGroups,
	    _getSailingDetails,
	    _getSailings,
	    _getShipCategories,
	    _getShips,
	    _handleVidanta;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		// Get ships when cruise line is selected
		$('#reservationcruisecomponentdetails-cruise_line_id').on('change', function change(e) {
			_getShips($(e.target).val());
		});

		// Get sailings and ship categories when ship is selected
		$('#reservationcruisecomponentdetails-ship_id').on('change', function change(e) {
			var ship_id = $(e.target).val();

			if (typeof $('#reservationcruisecomponentdetails-ship_category_id').data('selected-id') === 'undefined') {
				$('#reservationcruisecomponentdetails-category_name').val('');
			}

			_getSailings(ship_id);
			_getShipCategories(ship_id);
		});

		// Get sailing details and cruise groups when sailing is selected
		$('#reservationcruisecomponentdetails-itinerary_id').on('change', function change(e) {
			var itinerary_id = $(e.target).val();

			_getSailingDetails(itinerary_id);
			_getCruiseGroups(itinerary_id);
		});

		// Populate category name with selected category
		$('#reservationcruisecomponentdetails-ship_category_id').on('change', function change(e) {
			var $category      = $(e.target),
			    $category_name = $('#reservationcruisecomponentdetails-category_name'),
			    category_text  = $category.find(':selected').text();

			if ($category.val() !== '') {
				$category_name.val(category_text);
			}

			$category.data('old-name', category_text);
		});

		// Toggle other sailing fields when other sailing checkbox is checked/unchecked
		$('#reservationcruisecomponentdetails-other_sailing_date').on('change', function change(e) {
			if ($(e.target).prop('checked')) {
				$form.find('.sailing-details').addClass('hidden');
				$form.find('.invalid-warning').addClass('hidden');
				$form.find('.sailing').addClass('hidden');
				$form.find('.cruise-group').addClass('hidden');
				$form.find('.other-itinerary').removeClass('hidden');

				_handleVidanta(
					null,
					$('#reservationcruisecomponentdetails-sailing_date_hidden').val(),
					$('#reservationcruisecomponentdetails-return_date_hidden').val()
				);
			} else {
				$form.find('.other-itinerary').addClass('hidden');
				$form.find('.cruise-group').removeClass('hidden');
				$form.find('.sailing').removeClass('hidden');
				$form.find('.sailing-details').removeClass('hidden');
				$form.find('.invalid-warning').removeClass('hidden');

				_handleVidanta($('#reservationcruisecomponentdetails-itinerary_id').val());
			}
		});

		$('#reservationcruisecomponentdetails-sailing_date').on('dp.change', function dateChange(event) {
			_handleVidanta(
				null,
				$('#reservationcruisecomponentdetails-sailing_date_hidden').val(),
				$('#reservationcruisecomponentdetails-return_date_hidden').val()
			);
		});

		$('#reservationcruisecomponentdetails-return_date').on('dp.change', function dateChange(event) {
			_handleVidanta(
				null,
				$('#reservationcruisecomponentdetails-sailing_date_hidden').val(),
				$('#reservationcruisecomponentdetails-return_date_hidden').val()
			);
		});

		// Departure city search typeahead logic
		Adzuki.Typeahead(
			'#reservationcruisecomponentdetails-departure_city_search',
			'/Cities/search',
			function select(item, $self, typeahead) {
				$self.val(_formatCityName(item));

				typeahead.setHiddenValue(item.id);
			},
			function template(item) {
				return _formatCityName(item);
			}
		);

		// Return city search typeahead logic
		Adzuki.Typeahead(
			'#reservationcruisecomponentdetails-return_city_search',
			'/Cities/search',
			function select(item, $self, typeahead) {
				$self.val(_formatCityName(item));

				typeahead.setHiddenValue(item.id);
			},
			function template(item) {
				return _formatCityName(item);
			}
		);

		// Toggle confirmed seating if waitlisted is selected
		$('#reservationcruisecomponentdetails-waitlisted').on('change', function change(e) {
			if ($(this).prop('checked')) {
				$form.find('.confirmed-seating').removeClass('hidden');
			} else {
				$('#reservationcruisecomponentdetails-confirmed_seating').val('');

				$form.find('.confirmed-seating').addClass('hidden');
			}
		});

		// Toggle new group entry fields when new option is selected from cruise group drop-down
		$('#reservationcruisecomponentdetails-group_id').on('change', function change(e) {
			var group_id = $(this).val();

			if (group_id === '') {
				$form.find('.group-warning').addClass('hidden');
				$form.find('.amex-group-warning').addClass('hidden');
				$form.find('.create-group').addClass('hidden');
				$form.find('.create-amex-group').addClass('hidden');
			} else {
				$form.find('.group-warning').removeClass('hidden');

				if (group_id === 'new') {
					$form.find('.create-group').removeClass('hidden');
					$form.find('.amex-group-warning').addClass('hidden');
					$form.find('.create-amex-group').addClass('hidden');
				} else if (group_id === 'new_amex') {
					$form.find('.create-group').addClass('hidden');
					$form.find('.group-warning').addClass('hidden');
					$form.find('.amex-group-warning').removeClass('hidden');
					$form.find('.create-amex-group').removeClass('hidden');
				} else {
					$form.find('.create-group').addClass('hidden');
					$form.find('.amex-group-warning').addClass('hidden');
					$form.find('.create-amex-group').addClass('hidden');
				}
			}
		});

		// Auto-adjust final payment soft date when final payment due date is set
		$('#reservationcruisecomponentdetails-final_payment_date').on('dp.change', function dateChange(event) {
			var $soft_payment_date      = $('#reservationcruisecomponentdetails-soft_payment_date'),
				soft_payment_date       = null,
				formatted_soft_date     = null,
				new_soft_payment_date   = null,
				formatted_new_soft_date = null;

			if (event.date) {
				soft_payment_date = $soft_payment_date.data('DateTimePicker');

				if (soft_payment_date && soft_payment_date.date()) {
					formatted_soft_date = soft_payment_date.date().format("M/D/YYYY");
				} else {
					formatted_soft_date = "(No date entered)";
				}

				new_soft_payment_date = event.date;
				new_soft_payment_date.subtract($soft_payment_date.data('soft-date-days'), 'days');
				formatted_new_soft_date = new_soft_payment_date.format('M/D/YYYY');

				Adzuki.CustomConfirm({
					title  : 'Change soft date?',
					content: 'Would you like to change the Final Soft Payment Date for this component from ' + formatted_soft_date + ' to ' + formatted_new_soft_date + ' (' + parseInt($soft_payment_date.data('soft-date-days')) + ' days before the Final Payment Date)? Click \'Yes\' to update the Final Payment Soft Date or \'No\' to keep the current Final Payment Soft Date.',
					confirm: function confirm() {
						soft_payment_date.date(new_soft_payment_date);
						return true;
					}
				});
			}
		});

		// If cruise line id is already set, trigger appropriate JS to get ships and set other things
		if ($('#reservationcruisecomponentdetails-cruise_line_id').val() !== '') {
			$('#reservationcruisecomponentdetails-cruise_line_id').trigger('change');
		}

		// If this was an other itinerary, trigger the change so that proper form fields appear
		if ($('#reservationcruisecomponentdetails-other_sailing_date').prop('checked') === true) {
			$('#reservationcruisecomponentdetails-other_sailing_date').trigger("change");
		}
	};

	_formatCityName = function _formatCityName(item)
	{
		var name = item.name;

		if (item.state !== null) {
			name += ', ' + item.state;
		}

		if (item.country !== null) {
			name += ', ' + item.country;
		}

		return name;
	};

	_getCruiseGroups = function _getCruiseGroups(itinerary_id)
	{
		var $cruise_groups = $('#reservationcruisecomponentdetails-group_id'),
		    group_id;

		$cruise_groups.empty();
		$cruise_groups.append($('<option>').text('--Not Part of a Group--').attr('value', ''));

		$form.find('.group-warning').addClass('hidden');
		$form.find('.amex-group-warning').addClass('hidden');
		$form.find('.create-group').addClass('hidden');
		$form.find('.create-amex-group').addClass('hidden');

		if (itinerary_id === '') {
			return;
		}

		Adzuki.Ajax.get('/Reservations/getCruiseGroups/' + itinerary_id).then(function success(optgroups) {
			var optgroup;
			var sorted_data;
			var amex_manual_group = true;

			$.each(optgroups, function loadOptgroup(key, value) {
				optgroup = $('<optgroup>');

				if (key !== '0') {
					optgroup.attr('label', key);

					sorted_data = Adzuki.Sort.alphabeticValue(value);

					$.each(sorted_data, function loadCruiseGroup(i, cruise_group) {
						optgroup.append($('<option>').text(cruise_group.value).attr('value', cruise_group.key));
					});

					$cruise_groups.append(optgroup);
				}
			});

			if (typeof $cruise_groups.data('selected-id') !== 'undefined') {
				group_id = $cruise_groups.data('selected-id');

				// check for a manual amex cruise group
				if (group_id.indexOf('amex_cruise_group') !== -1) {
					$cruise_groups.find('option').each(function onEachCruiseGroup(i, el) {
						if (group_id === $(this).val()) {
							amex_manual_group = false;
							return false;
						}
					});

					if (amex_manual_group) {
						group_id = 'new_amex';
					}
				}

				$cruise_groups.val(group_id);
				$cruise_groups.trigger('change');
			}
		});
	};

	_getSailingDetails = function _getSailingDetails(itinerary_id)
	{
		var $sailing_details = $form.find('.sailing-details'),
		    $sailing_invalid = $form.find('.invalid-warning');

		$sailing_details.html('');

		if (!itinerary_id) {
			return;
		}

		Adzuki.Ajax.get('/Itineraries/getSailingDetails/' + itinerary_id).then(function success(sailing_details) {
			$sailing_details.html(sailing_details);
			$sailing_invalid.addClass('hidden');
		});

		_handleVidanta(itinerary_id);
	};

	_getSailings = function _getSailings(ship_id)
	{
		var $sailings = $('#reservationcruisecomponentdetails-itinerary_id'),
		    current_date = new Date(),
		    sailing_date,
		    key_parts,
		    sailing_parts,
		    itinerary_id = null,
		    only_active = 1;

		current_date = new Date(current_date.toDateString());

		$sailings.empty();
		$sailings.append($('<option>').text('Choose Sailing').attr('value', ''));
		$sailings.trigger('change');

		if (ship_id === '') {
			return;
		}

		Adzuki.Ajax.get('/CruiseSearch/getSailings/' + ship_id + '/1/' + only_active).then(function success(sailings) {
			$.each(sailings, function loadSailing(key, sailing) {
				key_parts = key.split('|');

				$sailings.append($('<option>').text(sailing).attr('value', key_parts[1]));

				if (itinerary_id === null) {
					sailing_parts = sailing.split(' - ');

					sailing_date = new Date(sailing_parts[0]);

					if (sailing_date >= current_date) {
						itinerary_id = key_parts[1];
					}
				}
			});

			if (typeof $sailings.data('selected-id') !== 'undefined') {
				itinerary_id = $sailings.data('selected-id');
				$sailings.removeAttr('data-selected-id');
				$sailings.removeData('selected-id');
			}

			$sailings.val(itinerary_id);

			$sailings.trigger('change');
		});
	};

	_getShipCategories = function _getShipCategories(ship_id)
	{
		var $ship_categories = $('#reservationcruisecomponentdetails-ship_category_id'),
		    url              = '/ShipCategories/getShipCategories/',
		    ship_category_id;

		$ship_categories.empty();
		$ship_categories.append($('<option>').text('Choose Category').attr('value', ''));
		$ship_categories.trigger('change');

		if (ship_id === '') {
			return;
		}

		url += ship_id;

		if (typeof $ship_categories.data('selected-id') !== 'undefined') {
			ship_category_id  = $ship_categories.data('selected-id');
			url              += '/' + ship_category_id;
		}

		Adzuki.Ajax.get(url).then(function success(ship_categories) {
			var sorted_ship_categories = Adzuki.Sort.alphabeticValue(ship_categories);

			$.each(sorted_ship_categories, function loadShipCategory(i, ship_category) {
				$ship_categories.append($('<option>').text(ship_category.value).attr('value', ship_category.key));
			});

			if (typeof $ship_categories.data('selected-id') !== 'undefined') {
				// ship_category_id = $ship_categories.data('selected-id');
				$ship_categories.removeAttr('data-selected-id');
				$ship_categories.removeData('selected-id');

				$ship_categories.val(ship_category_id);
			}
		});
	};

	_getShips = function _getShips(cruise_line_id)
	{
		var $ships           = $('#reservationcruisecomponentdetails-ship_id'),
		    $sailings        = $('#reservationcruisecomponentdetails-itinerary_id'),
		    $ship_categories = $('#reservationcruisecomponentdetails-ship_category_id'),
		    ship_id;

		$ships.empty();
		$ships.append($('<option>').text('Choose Ship').attr('value', ''));
		$ships.trigger('change');

		$sailings.empty();
		$sailings.append($('<option>').text('Choose Sailing').attr('value', ''));
		$sailings.trigger('change');

		$ship_categories.empty();
		$ship_categories.append($('<option>').text('Choose Category').attr('value', ''));
		$ship_categories.trigger('change');

		Adzuki.Ajax.get('/CruiseSearch/getShips/' + cruise_line_id).then(function success(ships) {
			var sorted_ships = Adzuki.Sort.alphabeticValue(ships);

			$.each(sorted_ships, function loadShip(i, ship) {
				$ships.append($('<option>').text(ship.value).attr('value', ship.key));
			});

			if (typeof $ships.data('selected-id') !== 'undefined') {
				ship_id = $ships.data('selected-id');
				$ships.removeAttr('data-selected-id');
				$ships.removeData('selected-id');

				$ships.val(ship_id);

				$ships.trigger('change');
			}
		});
	};

	_handleVidanta = function _handleVidanta(itinerary_id, sailing_date, return_date)
	{
		var uri = '/Itineraries/getVidantaEligibility/';

		if (parseInt($('#reservationcruisecomponentdetails-vidanta_promo').data('submitted')) === 0) {
			$('.vidanta-promo').addClass('hidden');

			if (itinerary_id !== '' || typeof sailing_date !== 'undefined') {
				if (itinerary_id === null) {
					uri += '0/' + sailing_date + '/' + return_date + '/';
				} else {
					uri += itinerary_id + '/null/null/';
				}

				uri += $('#reservationcruisecomponentdetails-vidanta_promo').data('cruise-component-id');

				Adzuki.Ajax.get(uri).then(function success(vidantaEligibility) {
					if (vidantaEligibility.eligible === true) {
						$('.vidanta-promo').removeClass('hidden');
					} else {
						$('#reservationcruisecomponentdetails-vidanta_promo').prop('checked', false);
					}
				});
			}
		}
	};

}(jQuery, window.Adzuki || {}));
